import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { AccountAction } from 'dashboard/models/account-action';
import { TriggerAccount } from 'dashboard/models/trigger';
import { WorkflowVersion } from 'dashboard/models/workflow-version';
import {
  AccountActionsFilterParams,
  setAccountActions,
  setAccountActionVersions,
  setTriggers,
} from 'dashboard/redux/actions/account-actions';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export const loadAccountActions = (
  accountTypeId: string,
  filters: AccountActionsFilterParams,
  sortParams: SortParams,
): DashboardThunkAction<Promise<void>> => {
  return async (dispatch: Dispatch) => {
    const params = {
      filter: {
        ...filters,
        'account-type-id': accountTypeId,
      },
      sort: `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
    };

    const { data: accountActionsResponse, included } = await SessionClientDashboard.listResource<
      AccountAction,
      {}
    >(ApiEndpoint.AccountAction, params);

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const actionVersions = included.filter(
      (item) => item.type === ApiModel.WorkflowVersion,
    ) as WorkflowVersion[];

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const triggers = included.filter(
      (item) => item.type === ApiModel.TriggerAccount,
    ) as TriggerAccount[];

    dispatch(setAccountActions(accountActionsResponse));
    dispatch(setAccountActionVersions(actionVersions));
    dispatch(setTriggers(triggers));
  };
};
